// extracted by mini-css-extract-plugin
export default {"loader":"loadingRenderer_loader__dk9It"};